import { render, staticRenderFns } from "./SendingComponent.vue?vue&type=template&id=4c745066&scoped=true"
import script from "./SendingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendingComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SendingComponent.vue?vue&type=style&index=0&id=4c745066&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c745066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c745066')) {
      api.createRecord('4c745066', component.options)
    } else {
      api.reload('4c745066', component.options)
    }
    module.hot.accept("./SendingComponent.vue?vue&type=template&id=4c745066&scoped=true", function () {
      api.rerender('4c745066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/billing/FacturaEDialog/components/SendingComponent.vue"
export default component.exports